UC.payments = {
  onTokenizeCardCallback: $.noop,
  onTokenizeBankAccountCallback: $.noop
};

UC.payments.STRIPE_NOT_READY_MESSAGE = 'Payment form is not ready. Please refresh the page.';

UC.payments.isStripeReady = function () {
  return !!window.Stripe && !!UC.constants && !!UC.constants.stripe_publisher_key;
};

UC.payments.createStripeClient = function () {
  if (!UC.payments.isStripeReady()) {
    return null;
  }

  try {
    return Stripe(UC.constants.stripe_publisher_key);
  } catch (err) {
    console.warn('Stripe client could not initialize: ' + err.message);
    return null;
  }
};

UC.payments.createCreditCardData = function (data) {
  var cardData = {
    number: data.cardNumber,
    cvc: data.cvc,
    exp_month: data.expireMonth,
    exp_year: data.expireYear,
    name: data.nameOnCard,
    address_line1: data.address,
    address_city: data.city,
    address_zip: data.zip,
    address_country: data.country
  };

  if (data.country && data.country == 'USA' && data.state) {
    cardData.address_state = data.state;
  }

  return cardData;
};

UC.payments.tokenizeBankAccount = function (accountData, callback) {
  var stripe = UC.payments.createStripeClient();

  if (!stripe) {
    UC.utils.sendNesEvent('payments_error', {ERROR: UC.payments.STRIPE_NOT_READY_MESSAGE});
    callback(UC.payments.STRIPE_NOT_READY_MESSAGE);
    return;
  }

  accountData.currency = accountData.currency || 'USD';
  stripe.createToken('bank_account', accountData)
    .then(function (response) {
      if (response && response.error) {
        UC.utils.sendNesEvent('payments_error', {ERROR: response.error.message});
        callback(response.error.message);
        return;
      }
      if (!response || !response.token || !response.token.id) {
        var errorMessage = 'Unable to tokenize bank account.';
        UC.utils.sendNesEvent('payments_error', {ERROR: errorMessage});
        callback(errorMessage);
        return;
      }
      callback(null, response.token.id);
    })
    .catch(function (err) {
      UC.utils.sendNesEvent('payments_error', {ERROR: err.message});
      callback(err.message);
    });
}

UC.payments.validateRoutingNumber = function (routingNumber, country) {
  const n = String(routingNumber).trim();

  if (country === 'US') {
    if (!/^\d{9}$/.test(n)) return false;

    // ABA checksum algorithm
    const d = n.split('').map(Number);
    const checksum =
      3 * (d[0] + d[3] + d[6]) +
      7 * (d[1] + d[4] + d[7]) +
      1 * (d[2] + d[5] + d[8]);

    return checksum % 10 === 0;
  }

  if (country === 'CA') {
    // Format: 0XXXYYYYY — leading zero, 3-digit institution, 5-digit branch
    return /^0\d{8}$/.test(n);
  }

  return false;
};

UC.payments.validateBankAccountNumber = function (accountNumber, country) {
  const n = String(accountNumber).trim();

  if (country === 'US') {
    // US bank accounts: 4–17 digits
    return /^\d{4,17}$/.test(n);
  }

  if (country === 'CA') {
    // Canadian account numbers: 7–12 digits
    return /^\d{7,12}$/.test(n);
  }

  return false;
};

UC.payments.formatRoutingNumber = function ( routingNumber, country) {
  routingNumber = routingNumber ? routingNumber.trim() : '';
  switch (country) {
    case 'US':
      return routingNumber.replace(/[^\w\s]/gi, '');
    case 'CA':
      routingNumber = routingNumber.replace(/[^\w\s]/gi, '');
      if (routingNumber.length >= 5) {
        return routingNumber.splice(5, '-');
      } else {
        return routingNumber;
      }
    default:
      return routingNumber;
  }
};
